import { Box, Fade, Modal } from "@mui/material";
import ExtraRequestImage from "../../../assets/extraRequestProduct.png";
import CloseIcon from "../../../assets/crossPayment.png";
import NewExtraRequestContent from "./NewExtraRequestContent";
import NewExtraRequestWithMessaging from "./NewExtraRequestWithMessaging";
import { useState } from "react";
import { useSelector } from "react-redux";
import { productSelector } from "../../../../../redux/slices/productSlice";
import { useLocation } from "react-router-dom";
import { isClientPreview } from "../../../../../utils/clientPreview";
import "../../orders/dispute_list/components/disputePreview.css";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "70%",
  height: "auto",
  textAlign: "center",
  bgcolor: "background.paper",
  border: "none",
  boxShadow: 24,
  p: "30px 70px",
  outline: "none",
  borderRadius: "10px",
};

export default function NewExtraRequestModal({
  open,
  setOpen,
  product,
  request,
  extraRequest,
}) {
  const handleClose = () => setOpen(false);
  const { productTabValue } = useSelector(productSelector);

  const [notes, setNotes] = useState("");

  const [option1, setOption1] = useState(false);
  const [option2, setOption2] = useState(false);

  const handleOption1Checkbox = (event) => {
    setOption1(event.target.checked);
  };
  const handleOption2Checkbox = (event) => {
    setOption2(event.target.checked);
  };

  let payload = { ...product };

  let options = {};
  if (typeof option1 === "string" || option1) {
    options.option1 = "Factory product pictures";
  }
  if (typeof option2 === "string" || option2) {
    options.option2 = "Sizing table";
  }
  payload.quotation_request = {
    notes,
    additional_notes: {
      client_note: notes,
    },
    options,
  };
  if (option1 || option2) {
    payload.requote_request = "SENT";
    if(product?.status === "accepted"){
      payload.status = product.status
    }
  }


  const boxShadow = "rgba(0, 0, 0, 0.05) 0px 0px 0px 1px";
  const location = useLocation().pathname;

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      BackdropProps={{
        sx: {
          backgroundColor: "rgba(0, 0, 0, 0.8)", // Adjust the opacity as needed
        },
      }}
    >
      <Fade in={open}>
        <Box sx={{ ...style, maxWidth: "860px" }} className="usend-dispute-sheet usend-extra-sheet">
          <div className="flexbox usend-dispute-head" style={{ padding: "0px 10px" }}>
            <div style={{ display: "flex", alignItems: "flex-start" }}>
              <div
                className="usend-dispute-icon"
                style={{
                  padding: "10px 12px 5px 12px",
                  borderRadius: "5px",
                  marginRight: "20px",
                  marginTop: "5px",
                  boxShadow: boxShadow,
                }}
              >
                <img src={ExtraRequestImage} alt="productIcon" />
              </div>
              <div style={{ textAlign: "left" }}>
                <h4 style={{ marginTop: 0, fontWeight: 600 }}>{isClientPreview() ? "Extra request" : "Extra Request"}</h4>
                <h6 style={{ marginTop: 10 }}>
                  {isClientPreview()
                    ? "Ask our team for more details about this product."
                    : "Request Additional Information about a product."}
                </h6>
              </div>
            </div>
            <img
              src={CloseIcon}
              alt="Close"
              className="usend-dispute-close"
              onClick={handleClose}
              style={{ cursor: "pointer" }}
            />
          </div>

          {product?.status === "accepted" &&
          location === "/customer/products" ? (
            <NewExtraRequestWithMessaging />
          ) : (
            <NewExtraRequestContent
              product={product}
              option1={option1}
              option2={option2}
              handleOption1Checkbox={handleOption1Checkbox}
              handleOption2Checkbox={handleOption2Checkbox}
              notes={notes}
              setNotes={setNotes}
              boxShadow={boxShadow}
              payload={payload}
              request={request}
              extraRequest={extraRequest}
              productTabValue={productTabValue}
              handleClose={handleClose}
            />
          )}
        </Box>
      </Fade>
    </Modal>
  );
}
